import type { Dispatch, SetStateAction } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import { api } from '@koridor/api-client';
import type { GameConfig } from '../contexts/GameContext';

export type GameLaunchConfig = GameConfig & { matchSessionId: string };

let lastLaunch: GameLaunchConfig | null = null;

export function peekLastLaunch() {
  return lastLaunch;
}

export function clearLastLaunch() {
  lastLaunch = null;
}

export function buildGameLaunch(cfg: GameConfig): GameLaunchConfig {
  return {
    ended: false,
    ...cfg,
    matchSessionId: cfg.matchSessionId ?? crypto.randomUUID(),
  };
}

/** Navigate to /game with router state so the screen opens with the right match immediately. */
export function launchGame(
  cfg: GameLaunchConfig,
  navigate: NavigateFunction,
  setGameCfg: Dispatch<SetStateAction<GameConfig>>,
) {
  lastLaunch = cfg;
  if (cfg.matchId) api.setActiveMatchId(cfg.matchId);
  else api.setActiveMatchId(null);
  setGameCfg(cfg);
  navigate('/game', { state: { launch: cfg } });
}
